class PatchersService {
    constructor ($resource) {
        this.resource = $resource(window.config.SYSTEM_URL + window.config.API_URL + '/patchers');
    }

    getAll = () => {
        return this.resource.query();
    };
}

export {
    PatchersService
};
